import styled from "@emotion/styled";

const MyDiv = styled.div`


`;

export default MyDiv;